const config = {
  BASE_URL: 'http://localhost:6019',
  PROD_URL: 'https://backend.assessments.chat',
}

export default config
